export const SET_CONTEXT_SEARCH = "SET_CONTEXT_SEARCH";
export const SET_ADMIN_MODE = "SET_ADMIN_MODE";